// assistia-sdk/src/rest/demo_clause.ts
// Types pour les endpoints démo clause bénéficiaire — api.luminya.eu/api/v1/
export class BeneficiaryClientImpl {
    http;
    sim;
    constructor(http, sim) {
        this.http = http;
        this.sim = sim;
    }
    generate(request) {
        return this.http.post('/api/v1/beneficiary_clause/generate', request, async () => ({
            output: {
                clause_text: 'Mon conjoint survivant non séparé de corps, à défaut mes enfants nés ou à naître par parts égales, vivants ou représentés, à défaut mes héritiers.',
                objective_code: request.preferences?.objective ?? 'A2',
                confidence: 0.95
            },
            generated_text: 'Mon conjoint survivant non séparé de corps, à défaut mes enfants nés ou à naître par parts égales, vivants ou représentés, à défaut mes héritiers.',
            confidence: 0.95,
            extraction_id: 'demo-extraction-001'
        }));
    }
    analyze(request) {
        return this.http.post('/api/v1/beneficiary_clause/analyze', request, async () => ({
            score: 95,
            niveau: 'conforme',
            motifs: [],
            recommandation: 'Clause bien structurée.'
        }));
    }
    listVariants() {
        return this.http.get('/api/v1/beneficiary_clause/variants', async () => []);
    }
    wizard(request) {
        return this.http.post('/api/v1/beneficiary_clause/wizard', request, async () => ({
            clause_text: 'Mon conjoint survivant...',
            explication: 'Wizard simulation',
            notes: [],
            legal_refs: []
        }));
    }
    remediate(request) {
        return this.http.post('/api/v1/beneficiary_clause/remediate', request, async () => ({
            proposition: 'Clause remédiée',
            explication: 'Explication',
            avertissement: 'Avertissement',
            fallback: true,
            model_used: 'rule-based'
        }));
    }
    analyzePortfolio(clauses) {
        return this.http.post('/api/v1/beneficiary_clause/portfolio', clauses, async () => ({
            total: clauses.length,
            conforme: clauses.length,
            vigilance: 0,
            critique: 0,
            score_moyen: 100,
            top_critiques: [],
            top_motifs: []
        }));
    }
}
export class RuleEngineClientImpl {
    http;
    sim;
    constructor(http, sim) {
        this.http = http;
        this.sim = sim;
    }
    score(request) {
        return this.http.post('/api/v1/rule_engine/score', request, async () => ({
            score: 100,
            penalties: [],
            status: 'conforme',
            triggered_rules: [],
            level: 'LOW'
        }));
    }
    getRules() {
        return this.http.get('/api/v1/rule_engine/rules', async () => []);
    }
    updateRule(code, body) {
        return this.http.patch(`/api/v1/rule_engine/rules/${code}`, body, async () => ({
            code,
            niveau: 'info',
            penalite: body.penalite ?? 0,
            enabled: true,
            description: body.description ?? ''
        }));
    }
    toggleRule(code) {
        return this.http.post(`/api/v1/rule_engine/rules/${code}/toggle`, {}, async () => ({
            code,
            niveau: 'info',
            penalite: 0,
            enabled: false,
            description: ''
        }));
    }
    resetRules() {
        return this.http.post('/api/v1/rule_engine/rules/reset', {}, async () => []);
    }
}
//# sourceMappingURL=demo_clause.js.map